module.exports = __webpack_public_path__ + "static/media/history.24561919.svg";